import { render, staticRenderFns } from "./shengchan.vue?vue&type=template&id=77a36ba0&"
import script from "./shengchan.vue?vue&type=script&lang=js&"
export * from "./shengchan.vue?vue&type=script&lang=js&"
import style0 from "./shengchan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports